import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { getThoughtsApiCrud, type GetThoughtsRequest } from "@/generated/fastapi";

export async function getThoughts(
  accessToken: string | null | undefined,
  request: GetThoughtsRequest,
) {
  const response = await getThoughtsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200) {
    throw new Error(`Failed to retrieve thoughts (${response.status})`);
  }

  return response.data ?? [];
}
